<template>
  <Input @refresh="refreshFiles" @upload="doUploadS3" :fileList="fileList" :currentConstruction="currentConstruction" />
</template>

<script>
import store from '../../../store'

const loadFiles = async (cloudConstructionId, apiOptions = {}) => {
  const params = {
    cloud_construction_id: cloudConstructionId,
    folder_path: "userdata/",
    __apiOptions: apiOptions
  }
  return store.dispatch("aws/fileListOf", params)  
}

export default {
  name: 'KokubanInput',
  components: {
    Input: () => import('../../../components/cloud/CreKokuban/ConstructionFolder/Input.vue')
  },
  props: {
    currentConstruction: Object
  },
  computed: {
    fileList(){
      return this.$store.getters['aws/result/curUserdataFileList']
    }
  },
  beforeRouteEnter(to, from, next) {
    loadFiles(to.params.cloudConstructionId).then(() => {
      if (store.getters['api/apiError']) {
        next(false);
        return;
      }
      next();
    });
  },
  methods: {
    async doUploadS3(file, apiOptions = {}){
      const params = {
        cloud_construction_id: this.$route.params.cloudConstructionId,
        file_path: `userdata/${file.name}`,
        file,
        __apiOptions: apiOptions
      }
      await this.$store.dispatch("aws/uploadTo", params)
    },
    async refreshFiles(apiOptions = {}){
      await loadFiles(this.$route.params.cloudConstructionId, apiOptions)
    }
  },
}
</script>

<style scoped>
</style>